import { css } from '@emotion/react';
import { Link } from 'gatsby';
import { dayjs } from '@/lib/dayjs';
import { pagesPath } from '@/lib/pagesPath';
import { getScreen } from '@/styles/media-query';
import { NewsForList } from '@/types/cms-types';

export type NewsCardProps = {
  className?: string;
  item: NewsForList;
};

export const NewsCard: React.FC<NewsCardProps> = ({ className, item }) => {
  return (
    <Link to={pagesPath.news._contentId(item.ipoNewsId).$url()}>
      <div
        css={css`
          display: grid;
          grid-template-areas:
            'title'
            'meta';
          grid-template-rows: 1fr auto;
          box-shadow: 0 0 16px rgba(40, 40, 40, 0.11);
          border-radius: 8px;
          position: relative;
          color: #5a5b6a;
          text-align: left;
          padding: 32px 24px 24px;

          @media ${getScreen('pc')} {
            padding: 40px 32px 32px;
          }
        `}
        className={className}
      >
        <p
          css={css`
            text-align: center;
            font: normal normal bold 10px/15px 'Noto Sans JP', sans-serif;
            letter-spacing: 0px;
            color: #ffffff;
            padding: 4px 15px;
            position: absolute;
            top: -10px;
            left: 24px;
            background: #00b3a7;
            border-radius: 44px;
            color: #fff;

            @media ${getScreen('pc')} {
              left: 32px;
            }
          `}
        >
          {item.category.title}
        </p>
        <p
          css={css`
            grid-area: title;
            font: normal normal 500 14px/26px 'Noto Sans JP', sans-serif;
            letter-spacing: 0.56px;
            color: #5a5b6a;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            overflow: hidden;

            @media ${getScreen('pc')} {
              -webkit-line-clamp: 4;
            }
          `}
        >
          {item.title}
        </p>
        <div
          css={css`
            grid-area: meta;
            display: flex;
            justify-content: space-between;
            margin-top: 36px;
            align-items: center;
          `}
        >
          <p
            css={css`
              font: normal normal normal 12px/15px 'din-2014', sans-serif;
              letter-spacing: 0.47px;
              color: #7d7d88;
            `}
          >
            {dayjs(item.publishedAt).format('YYYY/MM/DD')}
          </p>
          <span
            css={css`
              display: flex;
              align-items: center;
              gap: 8px;
              border: 1px solid #d1d8dd;
              border-radius: 44px;
              padding: 4px 22px 4px 25px;
              color: #7d7d88;
              font-size: 1rem;
            `}
          >
            <span>詳細</span>
            <i
              css={css`
                display: block;
                width: 5px;
                height: 9px;
                background: #d1d8dd;
                clip-path: path(
                  'M0.24884 0.350995C0.443908 0.15595 0.760174 0.155951 0.95524 0.350997L4.75143 4.14678C4.9465 4.34183 4.9465 4.65806 4.75143 4.8531L0.95524 8.64889C0.760174 8.84393 0.443908 8.84393 0.24884 8.64889C0.0537726 8.45384 0.053772 8.13761 0.248839 7.94257L3.69183 4.49994L0.248839 1.05732C0.053772 0.862271 0.0537726 0.54604 0.24884 0.350995Z'
                );
              `}
            ></i>
          </span>
        </div>
      </div>
    </Link>
  );
};
